import { render, staticRenderFns } from "./school-course-item.vue?vue&type=template&id=1296ad36&scoped=true"
import script from "./school-course-item.vue?vue&type=script&lang=js"
export * from "./school-course-item.vue?vue&type=script&lang=js"
import style0 from "./school-course-item.vue?vue&type=style&index=0&id=1296ad36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296ad36",
  null
  
)

export default component.exports